import { computeAcpAgentKey, computeAcpSessionAgentKey } from '../acp-agent.js';
import type { AcpManagerContext } from './acp-manager-context.js';
import type { HandlePromptOptions } from './types.js';

export type PromptRunContext = {
  activeRunId: string;
  activeAcpAgentKey: string;
  activeAcpSessionAgentKey: string;
  preferredForPrompt: string | null;
};

export function resolvePromptRunContext(
  ctx: AcpManagerContext,
  opts: Pick<HandlePromptOptions, 'runId' | 'mode' | 'agentType' | 'agentConfig' | 'sessionId'>,
): PromptRunContext | null {
  const { runId, mode, agentType, agentConfig, sessionId } = opts;
  const preferredForPrompt = (agentType ?? ctx.backendFallbackAgentType) ?? null;

  if (!runId) {
    ctx.log('[Agent] Prompt ignored: missing runId (cannot route session updates).');
    return null;
  }

  const acpAgentKey = computeAcpAgentKey(preferredForPrompt, mode, agentConfig ?? null);
  if (!acpAgentKey) {
    return null;
  }

  const activeAcpSessionAgentKey = computeAcpSessionAgentKey(sessionId, acpAgentKey);
  ctx.pendingCancelRunIds.delete(runId);
  ctx.promptRouting.registerRun({ sessionId, runId });
  ctx.runDispatch.set(runId, { acpSessionAgentKey: activeAcpSessionAgentKey });

  return {
    activeRunId: runId,
    activeAcpAgentKey: acpAgentKey,
    activeAcpSessionAgentKey,
    preferredForPrompt,
  };
}
